<template>
    <div class="notranslate">
        <div style="display: flex">
            <div style="padding-top: 3px;overflow: hidden;width: 100%;white-space:nowrap;">
                <div v-if="configsData.Prompted" class="prompted">
                    {{ configsData.Prompted }}
                </div>
            </div>
        </div>

        <div class="demo-text" v-if="active1 === 0">
            <div class="goods notranslate" ref="goodsWrapper" :style="{ height: goodsHeight + 'px', top: goodsTop + 'px' }">
                <div class="menu-wrapper" ref="menuWrapper" @scroll="handleScroll">
                    <mu-expansion-panel :expand.sync="payExpand" class="plan-pay-part" v-if="hasPayGoods">
                        <div slot="header" class="menu-group-header menu-group-pay">
                            {{ $t('buffet.payPark') }}
                        </div>
                        <ul class="menu-list notranslate" style="-webkit-overflow-scrolling: touch;">
                            <li v-for="(item, index) in buffetPayGoods" v-if="item.menuId == 0 && item.isShow && hasVisibleFood(item)"
                                :key="item.menuFoodTypeId" class="menu-item"
                                :class="{ 'current': item.menuFoodTypeId === currentMeneId }"
                                @click="selectMenu('good', index, item.menuFoodTypeId)">
                                <span class="menu-indicator"></span>
                                <span class="text">{{ item.menuFoodTypeName }}</span>
                                <span class="badge-tip" v-if="item.typeTotal > 0">{{ item.typeTotal }}</span>
                                <span class="hot-tag" v-if="item.isRecommend">
                                    <img src="../assets/image/hot.png" alt="" />
                                </span>
                            </li>
                        </ul>
                    </mu-expansion-panel>

                    <mu-expansion-panel :expand.sync="freeExpand" class="plan-free-part" v-if="hasFreeGoods">
                        <div slot="header" class="menu-group-header menu-group-free">
                            {{ $t('buffet.freePark') }}
                        </div>
                        <ul class="menu-list notranslate" style="-webkit-overflow-scrolling: touch;">
                            <li v-if="historyShow && !isSingleMode" class="menu-item" :class="{ 'current': currentMeneId == 10000 }"
                                @click="selectMenu('history', 10000, 10000)">
                                <span class="menu-indicator"></span>
                                <span class="text">{{ $t('buffet.history') }}</span>
                            </li>
                            <li v-for="(item, index) in buffetGoods" v-if="item.menuId == 0 && item.isShow && hasVisibleFood(item)" class="menu-item"
                                :key="item.menuFoodTypeId" :class="{ 'current': item.menuFoodTypeId === currentMeneId }"
                                @click="selectMenu('good', index, item.menuFoodTypeId)">
                                <span class="menu-indicator"></span>
                                <span class="text">{{ item.menuFoodTypeName }}</span>
                                <span class="badge-tip" v-if="item.typeTotal > 0">{{ item.typeTotal }}</span>
                                <span class="hot-tag" v-if="item.isRecommend">
                                         <img src="../assets/image/hot.png" alt="" />
                                </span>
                            </li>
                        </ul>
                    </mu-expansion-panel>
                </div>
                <div class="foods-wrapper notranslate" ref="foodsWrapper" @scroll="handleScroll"
                    style="background-color:#fff; min-height:0; height:100%;padding-bottom: 50px;">
                    <ul>
                        <li v-if="currSelectKey == 'history' && !isSingleMode">
                            <h1 class="title">{{ $t('buffet.history') }}</h1>
                            <div v-for="(item, index) in goods" :key="index" class="food-list food-list-hook">
                                <template v-for="(food, index1) in item.foodList">
                                    <div class="food-item" :key="index1" v-if="food.history == 1">
                                        <img v-if="hasImage(food.foodImage)" :style="foodImgStyle"
                                            :src="getImgUrl(food.foodImage, 200)" @click="selectFood(food)" />
                                        <div class="content">
                                            <h2 class="name">{{ food.foodName }}</h2>
                                            <div class="price-row">
                                                <div class="price">
                                                    <span class="now">{{ food.payAmount }} {{ seller.unit }}</span><span
                                                        v-show="food.actDiscount != 1" class="old">{{ food.price }}
                                                        {{ seller.unit }}</span>
                                                </div>
                                                <div class="cart-wrapper">
                                                    <cartcontrol :food="food" :package-type="0" :add-type="payClass" :person-num="personNum">
                                                    </cartcontrol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </li>
                        <template v-for="item in goods">
                            <li :key="item.menuFoodTypeId" class="food-list food-list-hook"
                                v-if="currentMeneId == item.menuFoodTypeId && currSelectKey == 'good'">
                                <h1 class="title">{{ item.menuFoodTypeName }}</h1>
                                <ul v-for="subType in subTypeList" :key="subType.menuFoodTypeId" class="food-item">
                                    <img v-if="hasImage(subType.foodTypeImage)" :style="foodImgStyle"
                                        :src="getImgUrl(subType.foodTypeImage, 200)" />
                                    <div class="content">
                                        <h2 class="name">{{ subType.menuFoodTypeName }}</h2>
                                        <div class="price-row">
                                            <div class="price">
                                            </div>
                                            <div class="cart-wrapper">
                                                <mu-badge :content="getChoice()" badge-class="badge-class" color="#da5b3a"
                                                    @click="openSelectSheet(subType.menuFoodTypeId)"></mu-badge>
                                            </div>
                                        </div>
                                    </div>
                                </ul>
                                <ul v-for="food in item.foodList" :key="food.foodId" class="food-item"
                                    v-if="food.foodId > 0  && food.isShow">
                                    <img v-if="hasImage(food.foodImage)" :style="foodImgStyle"
                                        :src="getImgUrl(food.foodImage, 400)" @click="selectFood(food)" />
                                    <div class="content">
                                        <h2 class="name">{{ food.foodName }}</h2>
                                        <div class="price-row">
                                            <div class="price">
                                                <span class="now">{{ food.payAmount }} {{ seller.unit }}</span><span
                                                    v-show="food.actDiscount != 1" class="old">{{ food.price }}
                                                    {{ seller.unit }}</span>
                                            </div>
                                            <div class="cart-wrapper">
                                                <cartcontrol :food="food" :package-type="0" :add-type="payClass" :person-num="personNum">
                                                </cartcontrol>
                                            </div>
                                        </div>
                                    </div>
                                </ul>
                            </li>
                        </template>
                    </ul>
                </div>
                <shopcart :select-foods="selectFoods" :add-type="payClass" :package-type="0" :is-seft="isSeft"
                    :is-seft-pay="isSeftPay">
                </shopcart>
                <food :food="selectedFood" :add-type="payClass" ref="food"></food>
            </div>
        </div>

        <div class="demo-text" v-if="active1 === 1">
            <seller></seller>
        </div>

        <div style="right:0;position:absolute;bottom:50px;" v-if="unPayTip != ''">
            <mu-chip class="demo-chip" key="1" color="error" @delete="removeTip(1)" delete>{{ unPayTip }}</mu-chip>
        </div>

        <mu-bottom-sheet :open.sync="selectOpen" style="overflow-y:auto;height:60%;">
            <mu-list @item-click="closeSelectSheet">
                <mu-sub-header>{{ $t('orderList.selectOne') }}</mu-sub-header>
                <mu-icon value="close" size="20" class="close-icon" @click="closeSelectSheet"></mu-icon>
                <div class="foods-wrapper notranslate">
                    <div v-for="(item, index0) in goods" :key="index0">
                        <div v-if="menuId == item.menuFoodTypeId">
                            <ul v-for="food in item.foodList" :key="food.foodId" class="food-item"
                                v-if="food.foodId > 0">
                                <img v-if="hasImage(food.foodImage)" :style="foodImgStyle"
                                    :src="getImgUrl(food.foodImage, 400)"
                                    @click="selectFood(food)" />
                                <div class="content">
                                    <h2 class="name">{{ food.foodName }}</h2>
                                    <div class="price-row">
                                        <div class="price">
                                            <span class="now">{{ Number(food.price * food.actDiscount).toFixed(0) }}
                                                {{ seller.unit }}</span><span v-show="food.actDiscount != 1" class="old">{{
                                                    food.price }}
                                            {{ seller.unit }}</span>
                                        </div>
                                        <div class="cart-wrapper">
                                            <cartcontrol :food="food" :package-type="0" :add-type="payClass"></cartcontrol>
                                        </div>
                                    </div>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
            </mu-list>
        </mu-bottom-sheet>

        <mu-dialog title="Recommended" :open.sync="openRecommended" :overlay-close="true" id="dialogRecommended"
            :lock-scroll="true">
            <div class="foods-wrapper" style="overflow-y: auto;overflow-x:hidden;margin:0px;"
                :style="{ height: screenHeight + 'px' }">
                <div style="position:absolute;top:0px;left:0px;z-index:2021090820">
                    <img width="48" height="48" src="../assets/image/round_close.png" @click="closeRecommended">
                </div>
                <ul>
                    <li v-for="(item, index) in goods" :key="index" class="food-list food-list-hook">
                        <div v-for="food in item.foodList" :key="food.foodId" class="food-item"
                            v-if="food.recommended == 2" style="display:block;">
                            <div class="pop"><img width="46" height="22" src="../assets/image/pop.gif"></div>
                            <div v-if="hasImage(food.foodImage)" style="display: block;"><img
                                    style="width:100%;object-fit: contain;" height="180"
                                    :src="getImgUrl(food.foodImage, 400)" /></div>
                            <div style="display: block;">
                                <h2
                                    style="margin: 5px 0 0 10px; height: 12px; line-height: 12px; font-size: 14px; color: #07111b;">
                                    {{ food.foodName }}</h2>
                                <div class="price" style="padding-top: 30px; margin-left: 10px;">
                                    <span
                                        style="font-size: 12px; color: #f01414; font-weight: 700; line-height: 24px; margin-right: 8px;">{{
                                            food.payAmount }}
                                        {{ seller.unit }}</span>
                                    <span v-show="food.actDiscount != 1"
                                        style=" font-size: 12px; text-decoration: line-through; color: #93999f; font-weight: 700; line-height: 24px;">{{
                                            food.price }}
                                        {{ seller.unit }}</span>
                                </div>
                                <div style=" position: absolute; right: 0; bottom: 12px;">
                                    <cartcontrol :food="food" :package-type="0" :add-type="payClass"></cartcontrol>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <div style="height: 46px; line-height: 46px; text-align: center; opacity: 0.4; background-color: rgb(0, 0, 0);color:#fff;"
                    v-if="openRecommended" @click="closeRecommended">
                    {{ $t('common.close') }}
                </div>

              
            </div>
        </mu-dialog>

        <mu-dialog :title="$t('orderList.orderChangeTip')" width="360" :open.sync="openOrderChange"
            :overlay-close="false" :esc-press-close="false">
            {{ $t('common.orderstatechange') }}
            <mu-button slot="actions" flat color="primary" @click="jumpOrderChange" style="color: #da5b3a;">
                {{ $t('common.sure') }}</mu-button>
        </mu-dialog>

        <mu-dialog :title="$t('orderList.limitTimeTitle')" width="360" :open.sync="openOverTimeTip"
            :overlay-close="false" :esc-press-close="false">
            {{ $t('orderList.limitTimeTips') }}
            <mu-button slot="actions" flat color="primary" @click="closeOverTimeTip" style="color: #da5b3a;">
                {{ $t('common.sure') }}</mu-button>
        </mu-dialog>
    </div>
</template>

<script>
import BScroll from 'better-scroll'
import shopcart from '../components/ShopCart'
import cartcontrol from '../components/CartControl'
import food from '../components/Food'
import seller from '../components/Seller'
import Vue from 'vue'

export default {
    inject: ['reload'],
    props: {
        isSeft: {
            type: Number,
            default: 0
        },
        isSeftPay: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            seller: {},
            currentIndex: 0,
            currentMeneId: 1,
            currSelectKey: '',
            active1: 0,
            goodsSourcs: [],
            goods: [],
            listHeight: [],
            scrollY: 0,
            selectedFood: {},
            curIndex: 0,
            panel: 0,
            selectOpen: false,
            recommendeds: [],
            openRecommended: false,
            screenHeight: document.documentElement.clientHeight - 60,
            goodsHeight: 0,
            goodsTop: 78,
            isFrist: true,
            tableOrderInfo: {},
            cartList: [],
            configsData: {},
            order: {},
            unPayTip: '',
            historyShow: false,
            openOrderChange: false,
            timer: null,
            once: 0,
            menuId: 0,
            isAtTop: true,
            payExpand: true,
            freeExpand: true,
            lastScrollTop: 0,
            personNum:1,
            openOverTimeTip:false,
            singleOrderId: null,
        }
    },
    computed: {
        payClass() {
            if (this.order != null && this.personNum>0) {
                var everybodyCopies = 200;
                if (this.configsData.EverybodyCopies != null) {
                    everybodyCopies = parseInt(this.configsData.EverybodyCopies.toString());

                    var curItemEverybodyCopies = 0;
                    var curTotalSeveral = 0;

                    let groupList = this.groupBy(this.cartList, (cart) => {
                        return cart.foodId
                    });
                 
                    if (groupList != null && JSON.stringify(groupList) != '{}') {
                        this.goods.forEach((good) => {
                            good.foodList.forEach((food) => {
                                if (groupList[food.foodId] != undefined && groupList[food.foodId].length > 0) {
                                    curItemEverybodyCopies = (food.quantity == null ? 0 : food.quantity) + groupList[food.foodId].length;
                                }
                                else {
                                    curItemEverybodyCopies = (food.quantity == null ? 0 : food.quantity)
                                }
                                curTotalSeveral += parseInt(food.several * curItemEverybodyCopies);
                              
                                if (food.perMaxCopies > 0 && (curItemEverybodyCopies >= (food.perMaxCopies * this.personNum))) {
                                    this.unPayTip = this.$t('orderList.onePersonOrder', { num: food.perMaxCopies }) + ' for ' + food.foodName;
                                    food.unPayTip = this.$t('orderList.onePersonOrder', { num: food.perMaxCopies });
                                    food.unAdd = true;
                                }
                                else if(food.everyTimeCopies>0&& food.quantity!=null && food.quantity>=food.everyTimeCopies){
                                    this.unPayTip = this.$t('orderList.maxEachTimeOrder', { num: food.everyTimeCopies }) + ' for ' + food.foodName;
                                    food.unPayTip = this.$t('orderList.maxEachTimeOrder', { num: food.everyTimeCopies });
                                    food.unAdd = true;
                                }
                                else {
                                    this.unPayTip = '';
                                    food.unPayTip = '';
                                    food.unAdd = false;
                                }
                            })
                        })
                    }
                    if (curTotalSeveral > (everybodyCopies * this.personNum)) {
                        this.unPayTip = this.$t('orderList.timeLimit', { num: (everybodyCopies * this.personNum) });
                        return true;
                    }
                    else {
                        this.unPayTip = '';
                        return false;
                    }
                }
            }
            this.unPayTip = '';
            return false;
        },
        selectFoods() {
            let foods = [];
            this.goods.forEach((good) => {
                good.foodList.forEach((food) => {
                    if (food.quantity) {
                      foods.push(food);
                    }

                    // if(food.childIds!=null && food.childIds!='' && food.childIds!='0'){
                    //     parentFoods.push(food);
                    // }
                })
            })
            return foods
        },
        subTypeList() {
            return this.goods.filter((item) => item.menuId == this.currentMeneId)
        },
        buffetPayGoods() {
            var payGoods = [];
            this.goods.forEach((good) => {
                let typeTotal = 0;
                good.foodList.forEach((food) => {
                    if (food.quantity) {
                        typeTotal += food.quantity;
                    }
                })
                if (good.isSeft == 0 && good.isSeftPay == 1) {
                    payGoods.push(Object.assign({}, good, { typeTotal }));
                }
            })
            payGoods.forEach((item1) => {
                if (item1.menuId == 0) {
                    let typeTotal0 = 0;
                    payGoods.forEach((item2) => {
                        if (item1.menuFoodTypeId == item2.menuId) {
                            typeTotal0 += item2.typeTotal;
                        }
                    })
                    item1.typeTotal += typeTotal0;
                }
            })
            return payGoods
        },
        buffetGoods() {
            var freeGoods = [];
            this.goods.forEach((good) => {
                let typeTotal = 0;
                good.foodList.forEach((food) => {
                    if (food.quantity) {
                        typeTotal += food.quantity;
                    }
                })
                if (good.isSeft == 1) {
                    freeGoods.push(Object.assign({}, good, { typeTotal }));
                }
            })
            freeGoods.forEach((item1) => {
                if (item1.menuId == 0) {
                    let typeTotal0 = 0;
                    freeGoods.forEach((item2) => {
                        if (item1.menuFoodTypeId == item2.menuId) {
                            typeTotal0 += item2.typeTotal;
                        }
                    })
                    item1.typeTotal += typeTotal0;
                }
            })
            return freeGoods
        },
        // 付费分组下是否有可展示的菜品分类，没有则隐藏整个 panel
        hasPayGoods() {
            return this.buffetPayGoods.some(item => item.menuId == 0 && item.isShow && this.hasVisibleFood(item));
        },
        // 免费分组下是否有可展示的菜品分类（含"历史"项），没有则隐藏整个 panel
        hasFreeGoods() {
            return (this.historyShow && !this.isSingleMode) || this.buffetGoods.some(item => item.menuId == 0 && item.isShow && this.hasVisibleFood(item));
        },
        // 是否单点模式（SingleService=1）
        isSingleMode() {
            return this.configsData.SingleService != null && String(this.configsData.SingleService) === '1';
        },
        // 菜品图片比例：默认 2:1；QrCodeImageRatio 配置为 "2:1"/"1:1"/"3:2"/"4:3"/"16:9" 等时按配置渲染
        foodImgStyle() {
            let ratioW = 2, ratioH = 1;
            const ratio = this.configsData.QrCodeImageRatio;
            console.log(ratio);
            if (ratio != null && ratio !== '') {
                const parts = String(ratio).split(':');
                const rw = parseFloat(parts[0]);
                const rh = parseFloat(parts[1]);
                if (rw > 0 && rh > 0) {
                    ratioW = rw;
                    ratioH = rh;
                }
            }
            // 1:1 正方形图片宽度用 100，其余比例宽度 140
            const width = (ratioW === ratioH) ? 100 : 140;
            const height = Math.round(width * ratioH / ratioW);
            return { width: width + 'px', height: height + 'px', objectFit: 'contain' };
        }
    },
    created() {
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
        window.removeEventListener('resize', this.calcGoodsHeight);
        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this.calcGoodsHeight);
        }
    },
    mounted() {
        this.tableOrderInfo = this.getItem('sessionStorage', 'tableOrderInfo');
        this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
        this.calcGoodsHeight();
        window.addEventListener('resize', this.calcGoodsHeight);
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.calcGoodsHeight);
        }
        this.initData();
        if (this.timer == null) {
            this.timer = setInterval(() => {
                this.checkOrder()
            }, 30000);
        }
    },
    methods: {
        calcGoodsHeight() {
            var vh = window.innerHeight;
            if (window.visualViewport) {
                vh = window.visualViewport.height;
            }
            var topEl = this.$el.querySelector('.demo-text');
            var topOffset = 78;
            if (topEl) {
                topOffset = topEl.offsetTop;
            }
            this.goodsTop = topOffset;
            var bottomOffset = 48;
            this.goodsHeight = vh - topOffset - bottomOffset;
        },
        initData() {
            this.isFrist = false;
            this.lastScrollTop = 0;
            this.curIndex = this.isSeft;
            this.getConfigs();
            this.getMenuList();
        },
        jumpOrderChange() {
            this.openOrderChange = false;
            this.$router.push({
                path: '/result'
            })
        },
        groupBy(list, fn) {
            const groups = {};
            list.forEach(function (o) {
                const group = JSON.stringify(fn(o));
                groups[group] = groups[group] || [];
                groups[group].push(o);
            });
            return groups;
        },
        checkOrder() {
            // 演示模式（model=demo）不校验订单状态
            if (this.$route.query.model === 'demo') {
                return;
            }
            this.openOrderChange = false;
            if (this.tableOrderInfo.tableName == undefined || this.tableOrderInfo.tableName == null || this.tableOrderInfo.tableName == '') {
                return;
            }
            let param = {
                tableName: this.tableOrderInfo.tableName,
                restaurantId: this.tableOrderInfo.restaurantId
            };
            // 单点模式：首次进入没有订单属于正常情况，校验逻辑走单独分支
            if (this.configsData.SingleService!=null && String(this.configsData.SingleService) === '1') {
                this.checkOrderSingle(param);
                return;
            }
            this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                .then(response => {
                    if (response.code == 200) {
                        var data = response.data;
                        if (data == null || data == '') {
                            clearInterval(this.timer);
                            this.timer = null;
                            this.openOrderChange = true;
                            this.openRecommended = false;
                        }
                        else{
                            if(this.configsData.BuffetTimeLimit!=undefined &&this.configsData.BuffetTimeLimit!=null)
                            if(this.isOverNMinutes(data.createTime,parseInt(this.configsData.BuffetTimeLimit))){
                                this.openOverTimeTip= true;
                            }
                        }
                    }
                });
        },
        // 单点模式订单校验：
        // 1. 未记录订单时查未支付订单，空属正常（尚未下单），不弹提示；首次拿到数据记录 orderId
        // 2. 已记录订单后用 CheckOrderState 校验订单是否仍存在，不存在说明订单状态已修改，弹出提示
        checkOrderSingle(param) {
            if (this.singleOrderId != null) {
                this.$get('QRCodeOrder/CheckOrderState', { orderId: this.singleOrderId })
                    .then(response => {
                        if (response.code == 200) {
                            var stateData = response.data;
                            if (stateData == null || stateData == '') {
                                clearInterval(this.timer);
                                this.timer = null;
                                this.singleOrderId = null;
                                this.openOrderChange = true;
                                this.openRecommended = false;
                            }
                            else{
                                 if(this.configsData.BuffetTimeLimit!=undefined &&this.configsData.BuffetTimeLimit!=null)
                                 if(this.isOverNMinutes(stateData.createTime,parseInt(this.configsData.BuffetTimeLimit))){
                                    this.openOverTimeTip= true;
                                 }
                            }
                        }
                    });
                return;
            }
            this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                .then(response => {
                    if (response.code == 200) {
                        var data = response.data;
                        if (data == null || data == '') {
                            return;
                        }
                        this.singleOrderId = data.orderId;
                        if(this.configsData.BuffetTimeLimit!=undefined &&this.configsData.BuffetTimeLimit!=null)
                        if(this.isOverNMinutes(data.createTime,parseInt(this.configsData.BuffetTimeLimit))){
                            this.openOverTimeTip= true;
                        }
                    }
                });
        },
        isOverNMinutes(createTime, n) {
            const createTimestamp = new Date(createTime).getTime();
            const nowTimestamp = Date.now();
            const diff = nowTimestamp - createTimestamp;
            return diff > n * 60 * 1000;
        },
        removeTip(index) {
            this.unPayTip = "";
        },
        async getConfigs() {
            await this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId })
                .then(response => {
                    if (response.code == 200) {
                        // 整体替换对象保证响应式（Vue2 直接给对象新增 key 不会触发 foodImgStyle 等 computed 重算）
                        const configs = {};
                        response.data.forEach((item) => {
                            configs[item.configKey] = item.configValue;
                            if(item.configKey=='OneTimeCharge'){
                               window.localStorage.setItem('oneTimeCharge', item.configValue);
                            }
                        })
                        this.configsData = configs;
                         if(this.configsData.Prompted1!=null && this.configsData.Prompted1!=''){
                                  this.$alert(this.configsData.Prompted1, this.$t("common.alert"), { okLabel: this.$t("common.sure") });
                            }
                    }
                });
        },
        goTop() {
            window.scrollTo(0, 0);
        },
        getChoice() {
            return this.$t('orderList.choice');
        },
        hasVisibleFood(item) {
            if (item.foodList.some(f => f.foodId > 0 && f.isShow)) {
                return true;
            }
            return this.goods.some(g => g.menuId == item.menuFoodTypeId && g.foodList.some(f => f.foodId > 0 && f.isShow));
        },
        selectDefaultFreeParkMenu() {
            let freeParkMenus = this.goods.filter((item) => item.menuId == 0 && item.isSeft == 1);
            let visible = freeParkMenus.find(item => this.hasVisibleFood(item));
            let target = visible || freeParkMenus[0];
            // 免费区（buffetGoods）无数据时，默认选中付费区（buffetPayGoods）第一个有菜品的分类
            if (!target) {
                let payParkMenus = this.goods.filter((item) => item.menuId == 0 && item.isSeft == 0 && item.isSeftPay == 1);
                target = payParkMenus.find(item => this.hasVisibleFood(item)) || payParkMenus[0];
            }
            if (target) {
                this.currentMeneId = target.menuFoodTypeId;
                this.selectMenu('good', 1, this.currentMeneId);
            }
        },
        toggle(panel) {
            this.panel = panel === this.panel ? 0 : panel;
        },
        _initScroll() {
            this.menuScroll = new BScroll(this.$refs.menuWrapper, {
                click: true,
            })
            this.foodsScroll = new BScroll(this.$refs.foodsWrapper, {
                click: true,
                probeType: 1,

            })
            this.foodsScroll.on('scroll', (pos) => {
                this.scrollY = Math.abs(Math.round(pos.y));
            })
        },
        _calculateHeight() {
            let foodList = this.$refs.foodsWrapper.getElementsByClassName('food-list-hook')
            let height = 0
            this.listHeight.push(height)
            for (let i = 0; i < foodList.length; i++) {
                let item = foodList[i]
                height += item.clientHeight
                this.listHeight.push(height)
            }
        },
        closeSelectSheet() {
            this.selectOpen = false;
        },
        openSelectSheet(menuId) {
            this.menuId = menuId
            this.selectOpen = true;
        },
        tabChange(value) {
        },
        selectMenu(key, index, foodTypeId, title) {
            this.currSelectKey = key;
            this.currentIndex = index;
            this.currentMeneId = foodTypeId;
            //let foodList = this.$refs.foodsWrapper.getElementsByClassName('food-list-hook');
            //let ref = foodList[0];
            this.$refs.foodsWrapper.scrollTop = 0;
            this.lastScrollTop =0;
        },
        selectFood(food) {
            this.selectedFood = food;
            this.$refs.food.show();
        },
        getMenuList() {
            let param = {
                restaurantId: this.tableOrderInfo.restaurantId,
                clientId: 1
            };
            this.$get('QRCodeOrder/GetBuffetFoodList', param)
                .then(response => {
                    if (response.code == 200) {
                        this.goods = response.data;
                        // 初始化 isShow 标记，确保没有未支付订单时也能正常显示菜单和菜品
                        this.goods.forEach((good) => {
                            Vue.set(good, 'isShow', true);
                            good.foodList.forEach((food) => {
                                Vue.set(food, 'isShow', true);
                            });
                        });
                        if (this.goods.length > 0) {
                            this.selectDefaultFreeParkMenu();
                        }
                        this.getPersonCartList();
                        this.getOrderList();
                        //setTimeout(() => {
                        //    //this._initScroll()
                        //    //this._calculateHeight()
                        //}, 200);
                    } else {
                        this.$alert(this.$t("common.connotAccessed"), this.$t("common.alert"), { okLabel: this.$t("common.sure") });
                    }
                });
        },
        getOrderList() {
            let param = {
                tableName: this.tableOrderInfo.tableName,
                restaurantId: this.tableOrderInfo.restaurantId
            };
            this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                .then(response => {
                    if (response.code == 200) {
                        var data = response.data;
                        if (data == null || data == '') {
                            return;
                        }
                        this.order = data;
                        this.tableOrderInfo.orderTime = this.order.orderDay.replace('/Date(', '').replace(')/', '');
                        this.$get('QRCodeOrder/GetQRcodeOrderList', { orderId: this.order.orderId })
                            .then(result => {
                                if (result.code == 200) {
                                    this.cartList = result.data;
                                    var cartPackageIds=[];
                                    if(this.cartList.length>0){
                                        this.personNum= this.cartList.filter(item => item.packageType > 1).reduce((sum, item) => sum + (item.quantity || 0), 0);
                                         cartPackageIds = this.cartList
                                                                    .filter(item => item.packageType > 1)
                                                                    .map(item => item.foodId); 
                                    }
                                    const seenFoodIds = new Set();
                                    this.goods.forEach((good) => {
                                        good.foodList.forEach((food) => {
                                            food.isShow = true;
                                            //校验是否有归属
                                            if (food.packageIds != null && food.packageIds != '') {
                                                const packageIdArr = food.packageIds.split(',').map(Number);
                                                const hasCommonId = cartPackageIds.some(id => packageIdArr.includes(id));
                                                if (hasCommonId) {
                                                    food.isShow = true;
                                                }
                                                else {
                                                    food.isShow = false;
                                                }
                                            }
                                            this.cartList.forEach((cart) => {
                                                if (food.foodId == cart.foodId&&!seenFoodIds.has(food.foodId)) {
                                                    seenFoodIds.add(food.foodId);
                                                    food.history = 1;
                                                    if(food.chargedOnce==1){
                                                        food.payAmount=0;
                                                    }
                                                    this.historyShow = true;
                                                    //校验是否不能新增了
                                                    if (food.perMaxCopies > 0) {
                                                        if (cart.quantity >= (food.perMaxCopies * this.personNum)) {
                                                             Vue.set(food, 'unAdd', true);
                                                             Vue.set(food, 'unPayTip', this.$t('orderList.oneOnlyOrder', { num: food.perMaxCopies }));
                                                        }
                                                    }
                                                    if(food.everyTimeCopies>0){
                                                        if(food.quantity!=null && food.quantity>=food.everyTimeCopies){
                                                            Vue.set(food, 'unAdd', true);
                                                            Vue.set(food, 'unPayTip', this.$t('orderList.maxEachTimeOrder', { num: food.everyTimeCopies }));
                                                        }
                                                    }
                                                }
                                            });
                                        });
                                    });
                                    // 过滤后若当前选中分类无可显示菜品，重新选择免费区第一个有菜品的分类
                                    var currentGood2 = this.goods.find(g => g.menuFoodTypeId == this.currentMeneId);
                                    if (!currentGood2 || !this.hasVisibleFood(currentGood2)) {
                                        this.selectDefaultFreeParkMenu();
                                    }
                                    this.once += 1
                                }
                            });
                    }
                });
        },
        getPersonCartList() {
            this.tableOrderInfo = this.getItem('sessionStorage', 'tableOrderInfo');
            let param = {
                RestaurantId: this.tableOrderInfo.restaurantId,
                TableName: this.tableOrderInfo.tableName,
                CreateUser: this.tableOrderInfo.name
            };
            this.$get('QRCodeOrder/GetPersonCart', param)
                .then(response => {
                    if (response.code == 200 && response.data.length > 0) {
                        var personCartList = response.data;
                        // 仅基于当前用户自己选的套餐做 packageIds 过滤
                        var personPackageIds = personCartList
                            .filter(item => item.packageType > 1)
                            .map(item => item.foodId);

                        if (personPackageIds.length > 0) {
                            this.goods.forEach((good) => {
                                good.foodList.forEach((food) => {
                                    food.isShow = true;
                                    if (food.packageIds != null && food.packageIds != '') {
                                        const packageIdArr = food.packageIds.split(',').map(Number);
                                        food.isShow = personPackageIds.some(id => packageIdArr.includes(id));
                                    }
                                });
                                var typeShowList = good.foodList.filter(it => it.isShow);
                                good.isShow = typeShowList.length > 0;
                            });
                            // 过滤后若当前选中分类无可显示菜品，重新选择免费区第一个有菜品的分类
                            var currentGood = this.goods.find(g => g.menuFoodTypeId == this.currentMeneId);
                            if (!currentGood || !this.hasVisibleFood(currentGood)) {
                                this.selectDefaultFreeParkMenu();
                            }
                        }

                        this.goods.forEach((good) => {
                            good.foodList.forEach((food) => {
                                personCartList.forEach((item) => {
                                    if (item.relatedId == food.relatedId) {
                                        if (!food.quantity) {
                                            Vue.set(food, 'quantity', item.quantity);
                                            if (item.decideName != null && item.decideName != '') {
                                                Vue.set(food, 'decideName', item.decideName);
                                                Vue.set(food, 'payAmount', item.price);
                                            }
                                        }
                                    }
                                });
                            });
                        });
                    }
                });
        },
        getImgUrl(image, w = 0) {
            if (image == undefined || image == 'undefined' || image == null || image == '') {
                return '../static/img/default.png';
            }
            if (w == 0) {
                return this.global.baseUrl + "uploads/" + image
            }
            return this.global.baseUrl + "api/images/" + w + "/" + image
        },
        // 是否配置了真实菜品图片（为空或默认图时不展示）
        hasImage(image) {
            if (image == undefined || image == 'undefined' || image == null || image === '') {
                return false;
            }
            return String(image).toLowerCase().indexOf('default.png') === -1;
        },
        getPath() {
            if (this.$route.path == '/buffet' && !this.isFrist) {
                this.getPersonCartList();
                this.getOrderList();
            }
        },
        handleScroll() {
            // const wrapper = this.$refs.foodsWrapper;
            // const menuWrapper = this.$refs.menuWrapper
            // const goodsWrapper = this.$refs.goodsWrapper;
            // const scrollTop = wrapper.scrollTop;
            // const delta =  scrollTop - this.lastScrollTop;
            // if (scrollTop === 0) {
            //     this.isAtTop = true;
            // } else {
            //     this.isAtTop = false;
            // }
            // if (wrapper.scrollTop > 0) {
            //     goodsWrapper.style.top = '20px';
            // }
            // if (menuWrapper.scrollTop > 0) {
            //     goodsWrapper.style.top = '20px';
            // }
            // if (this.isAtTop && delta < 0) {
            //     goodsWrapper.style.top = '60px';
            // }
            // this.lastScrollTop = scrollTop;
        },
        closeRecommended() {
            this.openRecommended = false;
        },
        closeOverTimeTip(){
            this.openOverTimeTip=false;
        },
    },
    watch: {
        '$route': 'getPath'
    },
    components: {
        shopcart,
        cartcontrol,
        food,
        seller
    }
}
</script>
<style scoped>
/deep/ .mu-expansion-toggle-btn.mu-button {
    margin-right: 0px !important;
}

#dialogRecommended>>>.mu-dialog {
    min-width: 90% !important;
}

#dialogRecommended>>>.mu-dialog-body {
    padding: 0 !important;
}

#dialogRecommended>>>.mu-dialog-title {
    background-color: #93999f;
    padding: 0;
    color: #fff;
    display: none;
}
</style>
<style lang="stylus" rel="stylesheet/stylus">
    .goods {
        position: fixed;
        left: 0;
        width: 100%;
        max-width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        overflow: hidden;
        background-color: #f5f5f5;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .goods .menu-wrapper {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100px;
        flex: 0 0 100px;
        background: #fafafa;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        min-height: 0;
        height: 100%;
        /* 底部留空，兼容全面屏安全区 + 手机浏览器工具栏遮挡最后一个分类 */
        padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 48px);
        box-sizing: border-box;
    }

    .goods .menu-wrapper::-webkit-scrollbar {
        width: 0px;
        background: transparent;
    }

    .goods .menu-wrapper .menu-list {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .goods .menu-wrapper .menu-item {
        position: relative;
        width: 100%;
        min-height: 54px;
        padding: 8px 8px 8px 12px;
        background: #fafafa;
        cursor: pointer;
        transition: background 0.15s, color 0.15s;
        border-bottom: 1px solid rgba(0,0,0,0.04);
        display: flex;
        align-items: center;
    }

    .goods .menu-wrapper .menu-item:active {
        background: #eee;
    }

    .goods .menu-wrapper .menu-item.current {
        background: #fff;
        color: #da5b3a;
        font-weight: 700;
    }

    .goods .menu-wrapper .menu-item.current .text {
        color: #da5b3a;
        font-weight: 700;
    }

    .goods .menu-wrapper .menu-item .menu-indicator {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 0;
        background: #da5b3a;
        border-radius: 0 2px 2px 0;
        transition: height 0.2s ease;
    }

    .goods .menu-wrapper .menu-item.current .menu-indicator {
        height: 24px;
    }

    .goods .menu-wrapper .menu-item .text {
        flex: 1;
        font-size: 12px;
        line-height: 1.3;
        font-weight: 500;
        color: #555;
        text-align: left;
        min-width: 0;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: normal;
        word-break: break-word;
    }

    .goods .menu-wrapper .menu-item.current .text {
        padding-right: 28px;
    }

        .goods .foods-wrapper {
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            -webkit-overflow-scrolling: touch;
            min-height: 0;
            height: 100%;
        }

            .goods .foods-wrapper h1 {
                margin: 0px;
            }

            .goods .foods-wrapper .title {
                padding-left: 14px;
                border-left: 2px solid #d9dde1;
                font-size: 12px;
                height: 26px;
                line-height: 26px;
                color: #93999f;
                background-color: #f3f5f7;
            }

            .goods .foods-wrapper .food-item {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                margin: 5px;
                padding-bottom: 10px;
                margin-right: 10px;
                position: relative;
            }

                .goods .foods-wrapper .food-item:after {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    border-top: 1px solid rgba(7,17,27,0.1);
                    content: '';
                }

                .goods .foods-wrapper .food-item:last-child:after {
                    border-top: 0;
                }

                .goods .foods-wrapper .food-item .icon {
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 57px;
                    flex: 0 0 57px;
                    margin-right: 10px;
                }

                .goods .foods-wrapper .food-item .content {
                    -webkit-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    margin-left: 5px;
                    display: flex;
                    flex-direction: column;
                }

                    .goods .foods-wrapper .food-item .content .price-row {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: auto;
                    }

                    .goods .foods-wrapper .food-item .content .name {
                        margin: 2px 0 8px 0;
                        height: 12px;
                        line-height: 12px;
                        font-size: 14px;
                        color: #07111b;
                    }

                    .goods .foods-wrapper .food-item .content .description,
                    .goods .foods-wrapper .food-item .content .extra {
                        font-size: 10px;
                        line-height: 10px;
                        color: #93999f;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                        height: 10px;
                        line-height: 10px;
                    }

                        .goods .foods-wrapper .food-item .content .extra .count {
                            margin-right: 12px;
                            line-height: 10px;
                        }

                        .goods .foods-wrapper .food-item .content .extra .rating {
                            line-height: 10px;
                        }

                    .goods .foods-wrapper .food-item .content .price .now {
                        font-size: 15px;
                        color: #f01414;
                        font-weight: 700;
                        line-height: 24px;
                        margin-right: 8px;
                    }

                    .goods .foods-wrapper .food-item .content .price .old {
                        font-size: 13px;
                        text-decoration: line-through;
                        color: #93999f;
                        font-weight: 700;
                        line-height: 24px;
                    }

                    .goods .foods-wrapper .food-item .content .cart-wrapper {
                        flex-shrink: 0;
                    }

    // 底部弹层等非 .goods 容器内的 food-item 同样保持 price 与 cart-wrapper 同行
    .foods-wrapper .food-item .content {
        display: flex;
        flex-direction: column;
    }

        .foods-wrapper .food-item .content .price-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: auto;
        }

        .foods-wrapper .food-item .content .price .now {
            font-size: 15px;
            color: #f01414;
            font-weight: 700;
            line-height: 24px;
            margin-right: 8px;
        }

        .foods-wrapper .food-item .content .price .old {
            font-size: 13px;
            text-decoration: line-through;
            color: #93999f;
            font-weight: 700;
            line-height: 24px;
        }

        .foods-wrapper .food-item .content .cart-wrapper {
            flex-shrink: 0;
        }


    .mu-icon-button {
        line-height: 1;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        font-size: 12px;
        margin-right: 0px;
        border: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: none;
        color: inherit;
        background-color: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .badge-tip {
        position: absolute;
        right: 6px;
        min-width: 18px;
        height: 18px;
        line-height: 18px;
        padding: 0 5px;
        border-radius: 9px;
        font-size: 10px;
        color: #fff !important;
        -webkit-text-fill-color: #fff !important;
        background: linear-gradient(135deg, #ff6b6b, #ff8787);
        font-weight: 700;
        text-align: center;
        box-shadow: 0 1px 3px rgba(238,9,121,0.4);
        z-index: 2;
        pointer-events: none;
    }

    .hot-tag {
        position: absolute;
        top: 5px;
        right: 4px;
        font-size: 10px;
        line-height: 1;
    }
    .hot-tag img{
        height: 20px;
    }


    /* ===== 分组标题 ===== */
    .menu-group-header {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 10px 10px;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0px;
        color: #fff;
        min-height: 32px;
        height: auto;
        line-height: 1.4;
        white-space: nowrap;
        width: 100%;
        box-sizing: border-box;
    }
    .menu-group-pay {
        color: #fff;
    }
    .menu-group-free {
        color: #fff;
    }
    .plan-pay-part .mu-expansion-panel-header {
        background: linear-gradient(135deg, #da5b3a, #e8856b);
    }
    .plan-free-part .mu-expansion-panel-header {
        background: linear-gradient(135deg, #4caf50, #66bb6a);
    }

    .mu-expansion-panel__expand {
        margin: 0px;
    }
    .mu-expansion-panel__expand .mu-expansion-panel-header {
        min-height: 32px;
    }
    .mu-expansion-panel-header {
        padding: 0px;
        width: 100%;
        min-height: 32px;
        border-radius: 0;
    }
    .mu-expansion-panel-header .mu-icon-button {
        display: flex;
        color: #fff;
    }
    .mu-expansion-panel-content {
        padding: 0px;
    }
    .mu-expansion-toggle-btn svg {
        width: 15px;
        height: 15px;
        fill: currentColor;
        flex-shrink: 0;
    }
    .mu-expansion-toggle-btn {
        margin-left: auto;
        margin-right: 8px;
        min-width: 28px;
        height: 28px;
    }
    .mu-icon-button {
        line-height: 1;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        font-size: 12px;
        margin-right: 0px;
        border: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: none;
        color: inherit;
        background-color: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .plan-pay-part {
        color: #da5b3a;
    }
    .plan-free-part {
        color: #4caf50;
    }
        .pop {
            position: absolute;
            top: 15px;
            right: 0px;
            transform: rotate(38deg);
            -o-transform: rotate(38deg);
            -webkit-transform: rotate(38deg);
            -moz-transform: rotate(38deg);
        }

        .badge-class {
            font-size: 16px;
        }

        .scroll-container {
            overflow: hidden;
            white-space: nowrap;
          }
           
          .prompted {
            display: inline-block;
            transform: translateX(100%);
            animation: scroll 50s linear infinite;
            will-change: transform;
            color:#DA5B3A;
            font-size: 13px;
          }
           
          @keyframes scroll {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(-100%);
            }
          }
</style>



// WEBPACK FOOTER //
// src/components/BuffetGoods.vue